import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const switchVariants = cva(
  "!p-[2px] peer data-[state=checked]:!bg-blue-500 data-[state=unchecked]:!bg-neutral-400 hover:data-[state=unchecked]:!bg-neutral-500 hover:data-[state=checked]:!bg-blue-600 focus-visible:!ring-ring/50 !inline-flex !shrink-0 !cursor-pointer !items-center !rounded-full !border-0 !shadow-xs !transition-all !outline-none focus-visible:!ring-[3px] disabled:!cursor-not-allowed disabled:!opacity-50",
  {
    variants: {
      size: {
        sm: "!h-4 !w-8",
        md: "!h-5 !w-9",
        lg: "!h-6 !w-11",
      },
    },
    defaultVariants: {
      size: "lg",
    },
  }
);

const thumbVariants = cva(
  "!bg-white !pointer-events-none data-[state=unchecked]:!shadow-[0_1px_2px_rgba(16,24,40,0.2)] !block !rounded-full !ring-0 !shadow-sm !transition-transform data-[state=unchecked]:!translate-x-0",
  {
    variants: {
      size: {
        sm: "!size-3 data-[state=checked]:!translate-x-4",
        md: "!size-4 data-[state=checked]:!translate-x-4",
        lg: "!size-5 data-[state=checked]:!translate-x-5",
      },
    },
    defaultVariants: {
      size: "lg",
    },
  }
);

type SwitchProps = React.ComponentProps<typeof SwitchPrimitive.Root> &
  VariantProps<typeof switchVariants> & {
    thumbClassName?: string;
  };

function Switch({ className, thumbClassName, size, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(switchVariants({ size }), className)}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(thumbVariants({ size }), thumbClassName)}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch, type SwitchProps };
